module.exports = __webpack_public_path__ + "img/500.0fbc0a75.png";